import React from "react";
import T from "prop-types";
import { usePageTitle } from "2g-hooks";
import { PageMessageError, PageMessageEmpty } from "2g-page-message";
import Loadbar from "2g-loadbar";

import { useDoplnkovaSluzba } from "b2b/api/hooks";
import { useServerMessage } from "b2b/i18n";
import DoplnkovaSluzbaEditaceWidget from "b2b/components/doplnkova-sluzba-editace-widget/DoplnkovaSluzbaEditaceWidget";

import useMessages from "./i18n/useMessages";

export function DoplnkovaSluzbaDetail({ id }) {
  const message = useServerMessage();
  const { titlePlaceholder, messageEmpty } = useMessages();
  const { data, loading, loaded, error } = useDoplnkovaSluzba({ id });

  usePageTitle(data ? message(data, "nazev") : titlePlaceholder());

  return (
    <>
      {loading && <Loadbar />}
      {error ? (
        <PageMessageError error={error} />
      ) : !data && loaded ? (
        <PageMessageEmpty message={messageEmpty()} />
      ) : (
        <DoplnkovaSluzbaEditaceWidget
          doplnkovaSluzba={data}
          loading={loading}
        />
      )}
    </>
  );
}

DoplnkovaSluzbaDetail.propTypes = { id: T.number.isRequired };

export default React.memo(DoplnkovaSluzbaDetail);
